import styled from "styled-components";

export const ContainerInput = styled.div``;

export const InputComponent = styled.input`
  border: 1px solid ${({ theme }) => theme.colors.neutral.neutral20};
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 16px;
`;
